import React, {
  useState,
  useRef,
  useEffect,
  SyntheticEvent,
  useContext
} from 'react'
import LocalesContext from 'components/_locales/localeContext'

import './styles.scss'
interface Props {
  data: { [key: string]: any }[]
  label?: string
  selected: (a: any) => void
  formatOption: (a: any) => string | JSX.Element
  filterFields?: (a: any) => string
  disabled?: boolean
  placeholder: string
  startsWidth?: boolean
}

export const MultiSelect = ({
  data,
  selected,
  formatOption,
  filterFields = d => d.name,
  label,
  disabled = false,
  placeholder = '',
  startsWidth = false
}: Props) => {
  const [filterstring, setFilter] = useState<string>('')
  const [showList, showHideList] = useState<boolean>(false)
  const [filteredData, setFilteredData] = useState<{}[]>([])
  const [focusedID, setFocusID] = useState<number>(-1)
  const focused = useRef<HTMLInputElement | HTMLButtonElement>()

  const preventFor = ['ArrowDown', 'ArrowUp']
  const __l: localesInterface = useContext<localesInterface>(LocalesContext)

  const handleKey = e => {
    let pressedkey = e.key
    let step = 1
    if (e.shiftKey) step = 10
    if (preventFor.indexOf(pressedkey) !== -1) {
      e.stopPropagation()
      e.preventDefault()
    }

    if (pressedkey === 'ArrowDown') {
      if (e.metaKey) {
        document
          .getElementsByClassName('b_' + (filteredData.length - 1))[0]
          .focus()
        setFocusID(filteredData.length - 1)
      } else {
        document.getElementsByClassName('b_' + (focusedID + step))[0].focus()
        setFocusID(focusedID + step)
      }
    }
    if (pressedkey === 'ArrowUp') {
      if (e.metaKey) {
        document.getElementsByClassName('b_' + 0)[0].focus()
        setFocusID(0)
      } else {
        if (focusedID - step <= -1) {
          document.getElementsByClassName('selectInput')[0].focus()
          setFocusID(-1)
        } else {
          document.getElementsByClassName('b_' + (focusedID - step))[0].focus()
          setFocusID(focusedID - step)
        }
      }
    }
    if (pressedkey === 'Enter') {
      let dd = data.find(f => f.name === e.target.dataset.value)
      if (dd) {
        setFilter('')
        selected(dd)
        showHideList(false)
      }
    }
  }
  const handleFocus = (event: SyntheticEvent) => event.target.select()

  useEffect(() => {
    if (!focused.current) return
    focused.current.focus()
  }, [focused.current, focusedID])

  useEffect(() => {
    if (!data) return
    setFilteredData(data)
  }, [])

  useEffect(() => {
    if (!data) return
    let filtered = data
      .filter(f =>
        startsWidth
          ? filterFields(f)
              .toLowerCase()
              .startsWith(filterstring.toLowerCase())
          : filterFields(f)
              .toLowerCase()
              .includes(filterstring.toLowerCase())
      )
      .sort((a, b) => a.name.length - b.name.length)
    setFilteredData(filtered)
  }, [filterstring, data])

  window.onclick = e => {
    showHideList(false)
  }
  return (
    <div
      className={'SearchSelect' + (disabled ? ' disabled' : '')}
      onClick={e => {
        e.stopPropagation()
      }}
    >
      <input
        placeholder={placeholder}
        className='selectInput'
        value={filterstring}
        type='text'
        onChange={e => {
          setFilter(e.target.value)
        }}
        onFocus={e => {
          if (window.innerWidth < 600) {
            e.target.parentElement.scrollIntoView()
          }
          handleFocus(e)
          showHideList(true)
        }}
        disabled={disabled}
        onKeyDown={handleKey}
      />

      <div className='smallabel'>{label}</div>
      {showList && filteredData.length > 0 && !disabled && (
        <div className='resultcontainer'>
          {filteredData.map((d, i) => {
            return (
              <button
                onKeyDown={handleKey}
                className={'b_' + i}
                key={i}
                onClick={() => {
                  setFilter('')
                  selected(d)
                  showHideList(false)
                }}
              >
                {formatOption(d)}
              </button>
            )
          })}
        </div>
      )}
      {showList && filteredData.length === 0 && !disabled && (
        <div className='resultcontainer'>
          <div className='noresult'>{__l.namecomp.noresult}</div>
        </div>
      )}
    </div>
  )
}
